<template>
	<div class="row student-history">
		<table class="table">
			<tr>
				<th>{{ 'Month' | translate }}</th>
				<th>{{ 'Date of payment' | translate }}</th>
				<th>{{ 'Days' | translate }}</th>
				<th>{{ 'Amount' | translate }}</th>
			</tr>
			<tr v-for="(invoice, index) in invoiceList" :key="index">
				<td>{{ parseMonth(invoice.created) }}</td>
				<td>
					{{ invoice.updated === null ? '' : invoice.updated.slice(0, 10) }}
				</td>
				<td>{{ invoice.paid_days }}</td>
				<td>{{ invoice.amount.slice(0, -3) }}</td>
			</tr>
		</table>
	</div>
</template>

<script>
export default {
	name: 'history',
	data() {
		return {
			invoiceList: [],
		}
	},
	created() {
		this.axios({
			method: 'get',
			url: `billing/invoices?user=${this.$store.state.myProfile.id}&status=paid`,
		}).then(response => {
			this.invoiceList = response.data
		})
	},
}
</script>

<style scoped>
.student-history {
	padding: 20px;
}
.table {
	border-radius: 10px;
	border: 1px solid #ddd;
	margin: 0 auto;
	background: #fff;
}
</style>
